import { Button, Modal } from "semantic-ui-react";
import { IParameter } from "../../models/parameter";
import { deleteParameter } from "../../services/parametersService";
import { toast } from "../..";

interface IProps {
    deleteParameterModalOpen: boolean;
    closeDeleteParameterModal: () => void;
    parameterToDelete: IParameter;
    refreshParameters: () => void;
}

export const DeleteParameterModal = ({
    deleteParameterModalOpen,
    closeDeleteParameterModal,
    parameterToDelete,
    refreshParameters,
}: IProps) => {
    const handleDeleteParameter = async () => {
        const response = await deleteParameter(parameterToDelete.guid);
        if (response) {
            toast("Parameter deleted successfully", true, 2000);
            refreshParameters();
        } else {
            toast("Error deleting parameter", false, 2000);
        }
        closeDeleteParameterModal();
    };

    return (
        <Modal open={deleteParameterModalOpen}>
            <Modal.Header>Delete parameter</Modal.Header>
            <Modal.Content>
                Are you sure you want to delete parameter {parameterToDelete.name}?
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={closeDeleteParameterModal} content="Cancel" />
                <Button primary onClick={handleDeleteParameter} content="Delete" />
            </Modal.Actions>
        </Modal>
    );
};
